import React from "react";

import { useCreateDocument } from "../useCreateDocument";
import { AuxiliaryComponent, DB_COLLECTION_NAMES } from "@constants";

function useCreateAuxiliaryComponent() {
  const { create } = useCreateDocument();

  const createAuxiliaryComponent = React.useCallback(
    function createAuxComponentCallback(data: AuxiliaryComponent) {
      return create(DB_COLLECTION_NAMES.AUXILIARY_COMPONENTS, data, data.id);
    },
    [create],
  );

  return { createAuxiliaryComponent };
}

export { useCreateAuxiliaryComponent };
